import React from 'react';
import ReactDOM from 'react-dom';
import styles from './ImagePopup.module.css';

interface ImagePopupProps {
    isOpen: boolean;
    imageUrl: string;
    onClose: () => void;
}

export const ImagePopup: React.FC<ImagePopupProps> = ({ isOpen, imageUrl, onClose }) => {
    if (!isOpen) return null;
    
    return ReactDOM.createPortal(
        <div className={styles.popupWrapper} onClick={onClose}>
            <button className={styles.closeButton} onClick={onClose}>✕</button>
            <img src={imageUrl} alt="Apartament zdjęcie popup" onClick={(e) => e.stopPropagation()}/>
        </div>,
        document.body
    );
};